import React from "react";
import { array } from "prop-types";

import { scrollToId } from "../../common/scrollHelpers.js";

const propTypes = { links: array };

const AnchorLinkNavigation = (props) => {
  const { links } = props;

  if (!links || links.length < 1) {
    return null;
  }

  const handleClick = (event, id) => {
    event.preventDefault();
    scrollToId(`#${id}`, true);
  };

  return (
    <nav className="anchor-link-navigation__app">
      <ul className="anchor-link-navigation__list">
        {links.map((link) => (
          <li key={link.id} className="anchor-link-navigation__item">
            <a
              onClick={(e) => handleClick(e, link.id)}
              className="anchor-link-navigation__link"
              href={link.href}
            >
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
AnchorLinkNavigation.propTypes = propTypes;
export default AnchorLinkNavigation;
